<template>
  <div
    class="d-flex auth-form-body"
    :style="minHeight ? `min-height:${minHeight}px` : ''"
  >
    <div class="w-50 d-flex align-items-center shadow-lg position-relative">
      <div class="px-5" ref="companyProfile">
        <AuthCompanyProfile />
      </div>
    </div>
    <div class="w-50 d-flex align-items-center auth-suggestion">
      <div class="w-50 mx-auto" ref="authForm">
        <div class="text-center">
          <h3 class="mb-4">პაროლის აღდგენა</h3>
          <div v-if="spinner" class="spinner mb-3">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <div v-if="error" class="alert alert-danger mb-4">
            <div>{{ errorMessage }}</div>
          </div>
          <div v-if="success" class="alert alert-success mb-4">
            <div>{{ successMessage }}</div>
          </div>
          <div class="text-center">
            გაიარეთ <router-link :to="{ name: 'signin' }" class="text-decoration-none"
              >ავტორიზაცია</router-link> თუ უკვე გაქვთ ანგარიში
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import axios from "@/http";
import AuthCompanyProfile from "@/components/AuthCompanyProfile.vue";
import useAuthMinHeight from "@/composables/useAuthMinHeight";

export default {
  components: { AuthCompanyProfile },
  props: ["token"],
  setup(props) {
    const spinner = ref(true);
    const error = ref(false);
    const errorMessage = ref(null);
    const success = ref(false);
    const successMessage = ref(null);

    const { minHeight, companyProfile, authForm } = useAuthMinHeight();

    const resetPassword = async () => {
      const res = await axios.post("/resetPassword", {
        token: props.token,
      });

      spinner.value = false;

      if (res.data.success) {
        success.value = true;
        successMessage.value = res.data.message;
      } else {
        error.value = true;
        errorMessage.value = "დაფიქსირდა შეცდომა";
      }
    };

    resetPassword();

    return {
      spinner,
      error,
      errorMessage,
      success,
      successMessage,
      companyProfile,
      authForm,
      minHeight,
    };
  },
};
</script>

<style>
</style>